// src/components/register/RegistrationWizard/Steps/EducationalForms/NinthTenthForm.js
import React, { useState, useEffect } from "react";
import Dropdown from "../../../../Usables/Dropdown/Dropdown";
import MultiSelectDropdown from "../../../../Usables/MultiSelectDropdown";
import FloatInputField from "../../../../Usables/FloatInputField";
import CurrentClass from "../../../../options/CurrentClass910";
import SchoolBoard from "../../../../options/schoolBoard";
import Olympiads from "../../../../options/Olympiads";
import Opportunities from "../../../../options/OpportunitiesTypes8th";
import Subjects from "../../../../options/InterestedSubjects8th";
import Streams from "../../../../options/Streams";

const NinthTenthForm = ({ onChange, data = {} }) => {
  // Form state
  const [currentclass, setCurrentClass] = useState(data.currentclass || "");
  const [schoolboard, setSchoolBoard] = useState(data.schoolBoard || "");
  const [schoolName, setSchoolName] = useState(data.schoolname || "");
  const [futurestream, setFutureStream] = useState(data.futurestream || "");
  const [olympiads, setOlympiads] = useState(data.olympiads ? JSON.parse(data.olympiads) : []);
  const [opportunities, setOpportunities] = useState(data.opportunities ? JSON.parse(data.opportunities) : []);
  const [subjects, setSubjects] = useState(data.subjects ? JSON.parse(data.subjects) : []);

  // Update parent component whenever form data changes
  useEffect(() => {
    onChange({
      currentclass,
      schoolBoard: schoolboard,
      schoolname: schoolName,
      futurestream,
      olympiads: JSON.stringify(getValuesArray(olympiads)),
      opportunities: JSON.stringify(getValuesArray(opportunities)),
      subjects: JSON.stringify(getValuesArray(subjects))
    });
  }, [currentclass, schoolboard, schoolName, futurestream, olympiads, opportunities, subjects, onChange]);

  // Helper function to extract values from multi-select options
  const getValuesArray = (options) => {
    if (!options || options.length === 0) return [];
    return options.map(option => option.value);
  };

  const handleCurrentClass = (e) => {
    setCurrentClass(e.value);
  };

  const handleSchoolBoard = (e) => {
    setSchoolBoard(e.value);
  };

  const handleSchoolName = (event) => {
    setSchoolName(event.target.value);
  };

  const handleFutureStream = (e) => {
    setFutureStream(e.value);
  };

  const handleOlympiads = (options) => {
    setOlympiads(options);
  };

  const handleOpportunities = (options) => {
    setOpportunities(options);
  };

  const handleSubjects = (options) => {
    setSubjects(options);
  };

  return (
    <div className="educational-form-content">
      <div className="form-section">
        <Dropdown
          name="class"
          value={currentclass}
          options={CurrentClass}
          placeHolder="Current Class"
          onChange={handleCurrentClass}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="schoolboard"
          value={schoolboard}
          options={SchoolBoard}
          placeHolder="School Board"
          onChange={handleSchoolBoard}
        />
      </div>
      
      <div className="form-section">
        <FloatInputField
          name="SchoolName"
          placeHolder="School Name"
          handleInput={handleSchoolName}
          inputVal={schoolName}
        />
      </div>
      
      <div className="form-section">
        <Dropdown
          name="streams"
          value={futurestream}
          options={Streams}
          placeHolder="Preferred Future Stream"
          onChange={handleFutureStream}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={Olympiads}
          onSelect={handleOlympiads}
          value={olympiads}
          placeholderDropdown="Olympiads Participated"
          placeholderInput="Search for olympiads"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={Opportunities}
          onSelect={handleOpportunities}
          value={opportunities}
          placeholderDropdown="Opportunities Types Interested In"
          placeholderInput="Search for interested fields"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
      
      <div className="form-section">
        <MultiSelectDropdown
          options={Subjects}
          onSelect={handleSubjects}
          value={subjects}
          placeholderDropdown="Subjects Preference"
          placeholderInput="Search for interested subjects"
          showSearchBar={true}
          showSelectAll={false}
        />
      </div>
    </div>
  );
};

export default NinthTenthForm;